module.exports = __webpack_public_path__ + "img/Menu-07.33761790.png";